import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const StyledTile = styled.button<{ clickable: boolean }>`
  display: flex;
  width: 120px;

  background-color: ${tokens.color.white};
  ${tokens.transition()};

  padding: ${tokens.spacer.x1};
  border: 1px solid ${tokens.color.ui_border_light};
  border-radius: ${tokens.radius.l};

  ${({ clickable }) => {
    if (!clickable) return 'pointer-events: none;';

    return `
      &:hover {
        cursor: pointer;
        background-color: ${tokens.color.neutral_200};
        border-color: ${tokens.color.ui_border};
      }
    `;
  }}
`;

export const StyledTileLeft = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${tokens.spacer.x0pt5};

  flex-grow: 1;
  align-items: flex-start;
  text-align: left;
`;

export const StyledTileTitle = styled.span`
  ${tokens.text('subtitle3')};
  color: ${tokens.color.text_light};
  line-height: 16px;
`;

export const StyledTileIcon = styled.span<{ color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;

  background-color: ${({ color }) => color};
  border-radius: ${tokens.radius.l};
`;

export const StyledValue = styled.div`
  ${tokens.text('subtitle1')};
`;
